<template lang="pug">
    div.d-flex.flex-column.align-items-flex-start(style="width: 100%;")
        .sender-name.cursor-default.ma-0.mt-1(v-if="!isSentByCurrentUser && isGroupChat") {{ message.user_full_name }}

        div.message-row(:class="isSentByCurrentUser ? 'justify-content-flex-end' : 'justify-content-flex-start'")

            div.message-bubble.cursor-default(:class="isSentByCurrentUser ? 'align-items-flex-end' : 'align-items-flex-start'")
                div.message-timestamp(:style="timestampStyle") {{ message.friendly_created_at }}

                template(v-if="messageHasMedia")
                    div(v-for="media in message.message_medias" style="display: flex; flex-direction: row; align-items: center;")
                        v-container.px-0(fluid)
                            template(v-if="isTempMessage")
                                v-skeleton-loader(type="image" width="125" height="125")
                            template(v-else)
                                Attachment(
                                    :is-link="true"
                                    :attachment="media"
                                )
                                
                MessageBubble.mb-1(
                    :dark="isSentByCurrentUser"
                    :class="isSentByCurrentUser ? 'blue' : 'bg-sms-message-gray'"
                    style="width: fit-content;"
                    v-if="bodyContainsText"
                )
                    .message-body {{ message.body }}

                .text-h3(v-else) {{ message.body }}

                div.last-message-status-container(v-show="displayLastMessageStatus")
                    span.mr-1.message-status.mb-1 {{ message.last_message_status }}

            v-icon.ml-2(v-if="messageSendFailed" color="error" small) mdi-alert-circle-outline
        
</template>

<script lang="ts">
import Vue from 'vue';
import VolieState from '@/store';

// Components
import Attachment from '@/components/shared/attachments/attachment_card.vue';
import MessageBubble from '@/components/communication_center/sms_message/message_bubble.vue';

export default Vue.extend({
    data() {
        return {
        }
    },
    computed: {
        bodyContainsText() {
            return this.emojiTrimmedBody?.length > 0;
        },
        currentUser() {
            return VolieState.currentUser();
        },
        displayLastMessageStatus() {
            return !this.loadingConversations && this.isSentByCurrentUser && this.isLastMessage && this.isLastConversation;
        },
        emojiTrimmedBody() {
            return (this.message?.body?.replaceAll(/\p{Extended_Pictographic}/ug, '' ) || '')?.trim();
        },
        isSentByCurrentUser() {
            return this.message.personable_id === this.currentUser.user_id;
        },
        messageHasMedia() {
            return this.message?.message_medias?.length > 0;
        },
        messageSendFailed() {
            return this.isSentByCurrentUser && this.message.status === 'error';
        },
        timestampStyle() {
            if (this.isSentByCurrentUser) {
                return {
                    left: '-60px',
                }
            }
            return {
                right: '-60px',
            }
        },
    },
    components: {
        Attachment,
        MessageBubble,
    },
    props: {
        isGroupChat: Boolean,
        isTempMessage: {
            type: Boolean,
            required: false,
            default: false,
        },
        message: {
            type: Object,
            required: true,
        },
        isLastMessage: Boolean,
        isLastConversation: Boolean,
        loadingConversations: Boolean,
    },
})
</script>

<style lang="scss" scoped>
    .message-row {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .sender-name, 
    .message-timestamp,
    .message-status {
        font-size: 12px;
        color: var(--volie-gray);
        margin-bottom: 5px;
    }

    .message-bubble {
        max-width: 80%;
        margin-top: 5px;
        position: relative;
        display: flex;
        flex-direction: column;

        .message-timestamp {
            visibility: hidden;
            position: absolute;
            top: 35%;
            margin-bottom: 5px;
        }

        .message-body {
            white-space: pre-wrap;
            word-break: break-word;
        }

        &:hover {
            .message-timestamp {
                visibility: visible;
            }
        }
    }

    .last-message-status-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

</style>